import {store} from '../index.js';

export const actionsLoadingTemplate =  async (callback, UIMutationTypes = 'ui/loadingEnable')=> {
    try {
        store.commit(UIMutationTypes, true);
        return await callback();
    } catch (e) {
        // handleException(e, failCallback);
        return Promise.reject(e);
    } finally {
        store.commit(UIMutationTypes, false);
    }
};

export const actionsNormalTemplate = async (callback)=> {
    try {
        return await callback();
    } catch (e) {
        // handleException(e, failCallback);
        return Promise.reject();
    }
};